/**
 * Default stroke multiplier at `size === 16` (1rem). When `strokeWidth` is omitted on an icon,
 * SVG stroke is `(16 / size) * DEFAULT_ICON_STROKE_WIDTH_MULTIPLIER`.
 *
 * **Reuse scope:** Project-wide — `@/components/icons`.
 */
export const DEFAULT_ICON_STROKE_WIDTH_MULTIPLIER = 1.3;

// MARK: resolve_icon_stroke_width
/**
 * Explicit `strokeWidth` wins; otherwise scales stroke with `size` so thickness stays consistent.
 *
 * **Reuse scope:** Project-wide — icon components.
 */
export function resolve_icon_stroke_width(size_px: number, strokeWidth: number | undefined): number {
    if (strokeWidth !== undefined) return strokeWidth;
    return (16 / size_px) * DEFAULT_ICON_STROKE_WIDTH_MULTIPLIER;
}
